var seller_type = /* @__PURE__ */ ((seller_type2) => {
  seller_type2["PRIVATE"] = "PRIVATE";
  seller_type2["COMMERCIAL"] = "COMMERCIAL";
  return seller_type2;
})(seller_type || {});
var FieldId = /* @__PURE__ */ ((FieldId2) => {
  FieldId2["BRAND"] = "brand";
  FieldId2["MODEL"] = "model";
  FieldId2["PRODUCTION_YEAR"] = "production_year";
  FieldId2["GENERATION"] = "generation";
  FieldId2["BODY_TYPE"] = "body_type";
  FieldId2["GEARBOX"] = "gearbox";
  FieldId2["DRIVETRAIN"] = "drivetrain";
  FieldId2["ENGINE"] = "engine";
  FieldId2["MILEAGE"] = "mileage";
  FieldId2["LOCATION"] = "location";
  FieldId2["STEERING_WHEEL"] = "steering_wheel";
  FieldId2["COLOR"] = "color";
  FieldId2["DOORS_COUNT"] = "doors_count";
  FieldId2["MODIFICATION"] = "modification";
  FieldId2["PACKAGE"] = "package";
  FieldId2["OWNERS_COUNT"] = "owners_count";
  FieldId2["STATES"] = "states";
  FieldId2["PTS_TYPE"] = "pts_type";
  FieldId2["PTS_IS_ORIGINAL"] = "pts_is_original";
  return FieldId2;
})(FieldId || {});
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["NUMBER"] = "number";
  FieldType2["OBJECT"] = "object";
  FieldType2["STRING"] = "string";
  FieldType2["BOOLEAN"] = "boolean";
  return FieldType2;
})(FieldType || {});
var FormId = /* @__PURE__ */ ((FormId2) => {
  FormId2["AVITO_ESTIMATE_FORM"] = "avito_estimate_form";
  FormId2["CM_EXPERT_ESTIMATE_FORM"] = "cm_expert_estimate_form";
  FormId2["AUTORU_ESTIMATE_FORM"] = "autoru_estimate_form";
  FormId2["REPORT_BY_VIN_FORM"] = "report_by_vin_form";
  FormId2["REPORT_BY_REG_NUMBER_FORM"] = "report_by_reg_number_form";
  return FormId2;
})(FormId || {});
var ReportStatus = /* @__PURE__ */ ((ReportStatus2) => {
  ReportStatus2["NOT_FOUND"] = "not_found";
  ReportStatus2["PROCESSING"] = "processing";
  ReportStatus2["SUCCESS"] = "success";
  ReportStatus2["ERROR"] = "error";
  return ReportStatus2;
})(ReportStatus || {});
var RuleId = /* @__PURE__ */ ((RuleId2) => {
  RuleId2["PATTERN"] = "pattern";
  RuleId2["MIN_LENGTH"] = "min_length";
  RuleId2["MAX_LENGTH"] = "max_length";
  RuleId2["GREATER_THAN"] = "greater_than";
  RuleId2["GREATER_THAN_OR_EQUAL"] = "greater_than_or_equal";
  RuleId2["LESS_THAN"] = "less_than";
  RuleId2["LESS_THAN_OR_EQUAL"] = "less_than_or_equal";
  return RuleId2;
})(RuleId || {});
var ServiceId = /* @__PURE__ */ ((ServiceId2) => {
  ServiceId2["AVITO"] = "avito";
  ServiceId2["CM_EXPERT"] = "cm_expert";
  ServiceId2["AUTORU"] = "autoru";
  return ServiceId2;
})(ServiceId || {});
var StageId = /* @__PURE__ */ ((StageId2) => {
  StageId2["STAGE_1"] = "stage_1";
  StageId2["STAGE_2"] = "stage_2";
  StageId2["STAGE_3"] = "stage_3";
  StageId2["STAGE_4"] = "stage_4";
  return StageId2;
})(StageId || {});
var WidgetType = /* @__PURE__ */ ((WidgetType2) => {
  WidgetType2["CHECKBOX"] = "checkbox";
  WidgetType2["SELECT"] = "select";
  WidgetType2["INPUT"] = "input";
  WidgetType2["RADIO"] = "radio";
  WidgetType2["AUTOCOMPLETE"] = "autocomplete";
  return WidgetType2;
})(WidgetType || {});
export {
  FieldId,
  FieldType,
  FormId,
  ReportStatus,
  RuleId,
  ServiceId,
  StageId,
  WidgetType,
  seller_type
};
